var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 27,
    viewBox: "0 0 15 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-154.000000, -1517.000000) translate(140.000000, 1518.000000) translate(15.000000, 0.000000)",
    stroke: "#000",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,22.8844712 L0,2.31553292 C0,1.09396549 0.979112932,0.1 2.18243587,0.1 L10.8175641,0.1 C12.020883,0.1 13,1.09396136 13,2.31553292 L13,22.8844671 C13,24.1060345 12.0208871,25.1 10.8175641,25.1 L2.1824318,25.1 C0.979112932,25.1 0,24.1060386 0,22.8844712 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99798045,23.1 C6.44747737,23.1 6,22.651525 6,22.1002528 C6,21.548475 6.4474722,21.1 6.99798045,21.1 C7.55050566,21.1 8,21.548475 8,22.1002528 C8,22.651525 7.55050566,23.1 6.99798045,23.1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M9.93951613 2.1L4.12701613 2.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6e10322ca33cc900aa076f306059207d.svg";
export { ForwardRef as ReactComponent };